import styled, { css } from "styled-components";
import { getDirection } from "../../../../../../../../common-deprecated/themes/common";

export const ColoursWrapper = styled.div`
    margin-${getDirection("left")}: -3px;
    ${({ theme }) => css`
        padding-top: ${theme.space[2]}px;
    `};
`;

export const Colour = styled.div<{ opacity: number; backgroundColor: string; isActive: boolean }>`
    display: inline-block;
    width: 20px;
    height: 20px;
    margin: 4px 3px 0;
    background-position: 50% 60%;
    background-size: 60px 60px;
    border: 1px solid ${({ theme }) => theme.color.grey2};
    border-radius: 50%;
    cursor: pointer;
    ${({ isActive }) =>
        isActive &&
        css`
            position: relative;
        `};
    ${({ opacity }) =>
        opacity &&
        css`
            opacity: ${opacity};
        `};
    ${({ backgroundColor }) =>
        backgroundColor &&
        css`
            background-color: ${backgroundColor};
        `};
`;

export const ActiveColour = styled.span`
    position: absolute;
    top: -4px;
    ${getDirection("left")}: -4px;
    width: 2.6rem;
    height: 2.6rem;
    border: 1px solid ${({ theme }) => theme.color.grey2};
    border-radius: 50%;
`;
